// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jo-1";
export var messageSideRight = "_jo-2";
export var subscribeToBackInStockBubbleContainer = "_jo-0";